import React from 'react';
import styles from '../view.module.css';

const Detail = ({ label, value }) => (
  <div className={styles.detail}>
    <span className={styles.detailLabel}>{label}</span>
    {value ? (
      <span className={styles.detailValue}>{value}</span>
    ) : (
      <span className={styles.detailEmpty}>-</span>
    )}
  </div>
);

export default Detail;
